<div class="overlay" [class.visible]="isHelpUsKnowSidebarOpen" (click)="closeHelpUsKnowSidebar()"></div>
<!-- Sidebar 1: Mood Selection -->
<div class="help-us-sidebar" *ngIf="isHelpUsKnowSidebarOpen">
  <div class="help-us-sidebar-sidebar-content">
    <button type="button" class="close-icon" (click)="closeHelpUsKnowSidebar()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
    <div class="first-image">
      <div class="share-icon" (click)="shareFeedbackViaWhatsApp()" *ngIf="roleType == 'autoverse_employee'">
        <mat-icon>share</mat-icon>
      </div>
      <img src="../../../../assets/images/help-us-knowmore-hi-image.png"
          alt="Manjunath"
          class="first-image-img" />
    </div>
    <h2>Hi, I'm Manjunath! 👋</h2>
    <p class="subtitle"> I'm here to listen to your feedback.<br /> Your opinion helps us improve <b>Autoverse</b> for you! </p>

    <div class="feedback-buttons">
      <button class="feedback-btn happy" *ngIf="feedbackOptions?.happy"  (click)="openStepTwoSidebar('happy')">
        {{ feedbackOptions.happy.heading }}
      </button>

      <button    class="feedback-btn okay" *ngIf="feedbackOptions?.okay"  (click)="openStepTwoSidebar('okay')">
        {{ feedbackOptions.okay.heading }}
      </button>

      <button   class="feedback-btn unhappy"  *ngIf="feedbackOptions?.unhappy"(click)="openStepTwoSidebar('unhappy')">
        {{ feedbackOptions.unhappy.heading }}
      </button>
    </div>
  </div>
</div>

<!-- Sidebar 2: Tag Selection -->
<div class="overlay" [class.visible]="isHelpUsKnowStepTwoOpen" (click)="closeHelpUsKnowStepTwoSidebar()"></div>
<div class="help-us-sidebar" *ngIf="isHelpUsKnowStepTwoOpen">
  <div class="second-sidebar-content">
    <h2 class="mood-title"> {{ feedbackOptions[selectedMood]?.subHeading }} </h2>
    <h3><strong> Tell us why you feel this way</strong></h3>
    <p class="subnote">Select one or more reasons below</p>
    <div class="tag-grid">
      <div class="feedback-line" *ngFor="let line of feedbackOptions[selectedMood]?.feedback">
        <button   class="tag-btn" *ngFor="let tag of line"[class.selected]="selectedReasons.includes(tag)"  (click)="toggleReason(tag)">
          {{ tag }}
        </button>
      </div>
    </div>
    <div class="back-wrapper"> 
      <button class="back-btn" (click)="goBackToStepOne()">
        <mat-icon>arrow_back</mat-icon>
        <div class="new" >Back</div>
      </button>
      <button class="continue-btn"
              [disabled]="selectedReasons.length === 0"
              (click)="openTellUsMoreSidebar()">Continue
        <mat-icon>arrow_forward</mat-icon>
      </button>
    </div>

  </div>
</div>


<!-- 3rd slider -->
 <div class="overlay" [class.visible]="showTellUsMoreSidebar" (click)="closeshowTellUsMoreSidebar()"></div>
  <div *ngIf="showTellUsMoreSidebar" class="sidebar-step-three">
    <h2 >Tell us more</h2>
    <p class="subheading">You can type, speak, or show us your issue — all optional.  </p>
    <textarea   class="feedback-textarea" placeholder="Type your feedback here..." (input)="onFeedbackTextChange($event)"></textarea>
    <!-- Record button -->
<button class="speak-btn" [ngClass]="{ 'recording': isRecording || hasRecorded }" (click)="toggleRecording()">
  {{ isRecording ? '⏹️ Stop Recording...' : hasRecorded ? '✅  Recorded.' : '🎤 Speak Feedback' }}
  <p *ngIf="isRecording">Recording: {{ formattedDuration }}</p>
</button>

<!-- Custom audio player UI -->
<div class="audio-player" *ngIf="hasRecorded">
  <button class="play-btn" (click)="togglePlay()">
    {{ isPlaying ? '⏸' : '▶' }}
  </button>
  <div class="progress-container">
<div class="dashed-progress">
  <div class="segment" [ngClass]="getSegmentClass(1)"></div>
  <div class="segment" [ngClass]="getSegmentClass(2)"></div>
  <div class="segment" [ngClass]="getSegmentClass(3)"></div>
  <div class="segment" [ngClass]="getSegmentClass(4)"></div>
</div>


  <div class="time-display">
    {{ currentTimeDisplay }} / {{ totalTimeDisplay }}
  </div>
</div>
  <i (click)="deleteRecording()">close</i>
</div>

    <!-- Add Photo -->
    <button  class="photo-btn"  (click)="fileInput.click()" >
      📷 Add Photo
    </button>
    <input  type="file"  accept="image/*"style="display: none"  #fileInput (change)="onPhotosSelected($event)"  multiple/>
    <!-- Display Photos -->
    <div class="uploaded-photos" *ngIf="uploadedPhotos.length > 0">
      <p>Attached Images</p>
      <div class="photo-container" *ngFor="let photo of uploadedPhotos; let i = index">
        <img [src]="photo" alt="Uploaded" />
        <button class="remove-photo" (click)="removePhoto(i)">✖</button>
      </div>
    </div>
    <div class="button-row">
      <button class="back-btn" (click)="goBackToPreviousSidebar()">
        <mat-icon>arrow_back</mat-icon>
        <div class="new" >Back</div>
      </button>
      <button class="submit-btn" (click) ="openThankyouSidebar()" >
        Submit Feedback
      </button>
    </div>
  </div>
<!-- =====================thank you- sidebar=============== -->
 <div class="overlay" [class.visible]="isThankyouSidebarOpen" (click)="closeThanksyouSidebar()"></div>
 <div class="thank-you" *ngIf="isThankyouSidebarOpen">
  <div class="thankyou-sidebar-content">
    <div class="first-image">
      <img src="../../../../assets/images/help-us-know-more-thank-you.png" alt="Manjunath" class="first-image-img" />
    </div>
    <h2>Thank you for helping us improve!</h2>
    <p class="thankyou-subtitle"> We will review your feedback and get back to you soon.</p>
    <div class="feedback-buttons">
      <button class="back-to-home"(click)="closeThanksyouSidebar()"> Back to Home</button>
    </div>
  </div>
  
</div>